<template>
  <div   class="m-4 md:mx-8 md:mt-16" >
      <div ref="print">
    <h1 class="px-4 md:px-8 py-2 text-2xl font-bold bg-primario text-gray-200 tracking-wide">
      {{ $t("lang.msg.technicalSheet") }}
    </h1>
      <h3 class="px-2 md:px-4 py-2 text-1xl font-bold bg-white text-gray-800 tracking-wide">
          {{ $t("lang.msg.reference2") }} : {{reference2}}</h3>
    <section class="mt-2" >
      <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
        <h2>{{ $t("lang.msg.garmentCharacteristics") }}</h2>
      </div>

      <div class="bg-white px-4 md:px-8 divide-y-2 divide-gray-300">
        <div
          v-for="(garment, garmentIndex) in garments.content"
          :key="`garment_${garmentIndex}`"
          class="py-8"
        >
          <!-- === MAIN CLOTHE FEATURE RADIO BUTTON === -->
          <div class="flex justify-between">
            <div class="flex space-x-6">
              <label class="inline-flex items-center cursor-pointer">
                <input
                  v-model="garments.clotheFeatureMain"
                  class="form-radio"
                  type="radio"
                  name="garment"
                  :value="garmentIndex"
                >
                <span class="ml-2">{{ $t("lang.msg.main") }}</span>
              </label>
              <label class="inline-flex items-center cursor-pointer">
                <input
                  class="form-radio"
                  type="checkbox"
                  disabled
                  name="garment"
                  :checked="garmentIndex != garments.clotheFeatureMain"
                  :value="garmentIndex"
                >
                <span class="ml-2">{{ $t("lang.msg.secondary") }}</span>
              </label>
            </div>
            <div class="flex space-x-2">
              <ButtonRounded
                v-if="garments.content.length > 1"
                @action="removeRowOrOpenModal(garments.content, garmentIndex, 'idClotheFeature')"
                color="red"
              >
                <IconRemove />
              </ButtonRounded>
              <ButtonRounded v-if="garmentIndex == garments.content.length - 1" @action="addNewRow(garments, 'garments')" color="blue">
                <IconAdd />
              </ButtonRounded>
            </div>
          </div>
          <!-- ====================== -->
          <!-- === CLOTHE FEATURE === -->
          <!-- ====================== -->
          <div class="py-2 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            <InputWrapper :label="$t('lang.msg.tissue')" content="input" block>
              <Select
                id="idTissue"
                :data="tissues"
                :track-by="getLangLabel('tissue')"
                v-model.number="garment.idTissue"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.quality')" content="input" block>
              <Select
                id="idQuality"
                :data="qualities"
                :track-by="getLangLabel('quality')"
                v-model.number="garment.idQuality"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.weight')" content="input" block>
              <Select
                id="idWeight"
                :data="weights"
                :track-by="getLangLabel('weight')"
                v-model.number="garment.idWeight"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.joinLife')" content="input" block>
              <div class="mt-2 flex">
                <label class="inline-flex items-center">
                  <input
                    v-model="garment.joinLife"
                    type="radio"
                    class="form-radio"
                    :value="true"
                  >
                  <span class="ml-2 cursor-pointer">OK</span>
                </label>
                <label class="inline-flex items-center ml-6">
                  <input
                    v-model="garment.joinLife"
                    type="radio"
                    class="form-radio"
                    :value="false"
                  >
                  <span class="ml-2 cursor-pointer">NO</span>
                </label>
              </div>
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.title')" content="input" block>
              <Select
                id="idTittle"
                :data="titles"
                :track-by="getLangLabel('tittle')"
                v-model.number="garment.idTittle"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.lu')" content="input" block>
              <Select
                id="idLu"
                :data="lus"
                :track-by="getLangLabel('lu')"
                v-model.number="garment.idLu"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.galga')" content="input" block>
              <Select
                id="idHound"
                :data="galga"
                :track-by="getLangLabel('hound')"
                v-model.number="garment.idHound"
              />
            </InputWrapper>
          </div>
          <!-- ========================= -->
          <!-- ===  COMPOSITION LIST === -->
          <!-- ========================= -->
          <div
            v-for="(composition, compositionIndex) in garment.compositions.content"
            :key="`composition_${compositionIndex}`"
            class="mt-6 grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4 items-end"
          >
            <InputWrapper :label="$t('lang.msg.composition')" content="input" block>
              <Select
                id="idCompositionList"
                :data="compositionsSelect"
                :track-by="getLangLabel('compositionList')"
                :placeholder="$t('lang.msg.composition')"
                v-model.number="composition.idCompositionList"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.percent')" content="input" block>
              <InputText v-model.number="composition.percents" name="%" />
            </InputWrapper>
            <div class="flex justify-between">
              <div class="flex space-x-2">
                <ButtonRounded
                  v-if="garment.compositions.content.length > 1"
                  @action="removeRowOrOpenModal(garment.compositions.content, compositionIndex, 'idClotheFeatureComposition')"
                  color="red"
                >
                  <IconRemove />
                </ButtonRounded>
                <ButtonRounded
                  v-if="compositionIndex == garment.compositions.content.length - 1"
                  @action="addNewRow(garment.compositions, 'compositions')"
                  color="blue"
                >
                  <IconAdd />
                </ButtonRounded>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============= -->
    <!-- === PRINT === -->
    <!-- ============= -->
    <section ref="print2">
      <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
        <h2>{{ $t("lang.msg.print") }}</h2>
      </div>
      <div class="bg-white p-4 md:p-8">
        <div
          v-for="(print, printIndex) in prints.content"
          :key="`print_${printIndex}`"
          class="grid grid-row-1 grid-cols-1 md:grid-cols-2 xl:grid-cols-sheet gap-2 mb-8 xl:mb-4 items-end"
        >
          <label class="inline-flex items-center cursor-pointer mb-1">
            <input
              v-model="prints.printsMain"
              class="form-radio"
              type="radio"
              name="print"
              :value="printIndex"
            >
            <span class="ml-2">{{ $t("lang.msg.main") }}</span>
          </label>
          <InputWrapper :label="$t('lang.msg.print')" content="input" block>
            <Select
              id="idPrintList"
              ref="idPrintList"
              :data="printsSelect"
              :track-by="getLangLabel('printList')"
              v-model.number="print.idPrintList"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.ubication')" content="input" block>
            <Select
              id="idUbication"
              :data="ubications"
              :error="false"
              :track-by="getLangLabel('ubication')"
              v-model.number="print.idUbication"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.description')" content="input" block>
            <InputText v-model="print.printText" :name="$t('lang.msg.description')" />
          </InputWrapper>
          <div class="flex justify-end">
            <div class="flex space-x-2">
              <ButtonRounded
                v-if="prints.content.length > 1"
                @action="removeRowOrOpenModal(prints.content, printIndex, 'idPrint')"
                color="red"
              >
                <IconRemove />
              </ButtonRounded>
              <ButtonRounded v-if="printIndex == prints.content.length - 1" @action="addNewRow(prints, 'prints')" color="blue">
                <IconAdd />
              </ButtonRounded>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- =================== -->
    <!-- === COMPLEMENTS === -->
    <!-- =================== -->
    <section ref="print3">
      <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
        <h2>{{ $t("lang.msg.complements") }}</h2>
      </div>
      <div class="bg-white p-4 md:p-8">
        <div
          v-for="(complement, complementIndex) in complements.content"
          :key="`complement_${complementIndex}`"
          class="grid grid-row-1 grid-cols-1 md:grid-cols-2 xl:grid-cols-sheet gap-2 mb-8 xl:mb-4 items-end"
        >
          <label class="inline-flex items-center cursor-pointer mb-1">
            <input
              v-model="complements.complementMain"
              class="form-radio"
              type="radio"
              name="complement"
              :value="complementIndex"
            >
            <span class="ml-2">{{ $t("lang.msg.main") }}</span>
          </label>
          <InputWrapper :label="$t('lang.msg.complements')" content="input" block>
            <Select
              id="idComplementList"
              ref="idComplementList"
              :data="complementsSelect"
              :track-by="getLangLabel('complementList')"
              v-model.number="complement.idComplementList"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.ubication')" content="input" block>
            <Select
              id="idUbication"
              :data="ubications"
              :error="false"
              :track-by="getLangLabel('ubication')"
              v-model.number="complement.idUbication"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.description')" content="input" block>
            <InputText v-model="complement.complementText" :name="$t('lang.msg.description')" />
          </InputWrapper>
          <div class="flex justify-end">
            <div class="flex space-x-2">
              <ButtonRounded
                v-if="complements.content.length > 1"
                @action="removeRowOrOpenModal(complements.content, complementIndex, 'idComplement')"
                color="red"
              >
                <IconRemove />
              </ButtonRounded>
              <ButtonRounded v-if="complementIndex == complements.content.length - 1" @action="addNewRow(complements, 'complements')" color="blue">
                <IconAdd />
              </ButtonRounded>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====================== -->
    <!-- === MAKING DETAILS === -->
    <!-- ====================== -->
    <section ref="print4">
      <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
        <h2>{{ $t("lang.msg.confectionDetails") }}</h2>
      </div>
      <div class="bg-white p-4 md:p-8">
        <div
          v-for="(making, makingIndex) in makingDetails.content"
          :key="`making_${makingIndex}`"
          class="grid grid-row-1 grid-cols-1 md:grid-cols-2 xl:grid-cols-sheet gap-2 mb-8 xl:mb-4 items-end"
        >
          <label class="inline-flex items-center cursor-pointer mb-1">
            <input
              v-model="makingDetails.makingDetailMain"
              class="form-radio"
              type="radio"
              name="making"
              :value="makingIndex"
            >
            <span class="ml-2">{{ $t("lang.msg.main") }}</span>
          </label>
          <InputWrapper :label="$t('lang.msg.confectionDetails')" content="input" block>
            <Select
              id="idMakingList"
              ref="idMakingList"
              :data="makingDetailsSelect"
              :track-by="getLangLabel('makingList')"
              v-model.number="making.idMakingList"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.ubication')" content="input" block>
            <Select
              id="idUbication"
              :error="false"
              :data="ubications"
              :track-by="getLangLabel('ubication')"
              v-model.number="making.idUbication"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.description')" content="input" block>
            <InputText v-model="making.makingDetailText" :name="$t('lang.msg.description')" />
          </InputWrapper>
          <div class="flex justify-end">
            <div class="flex space-x-2">
              <ButtonRounded
                v-if="makingDetails.content.length > 1"
                @action="removeRowOrOpenModal(makingDetails.content, makingIndex, 'idMakingDetail')"
                color="red"
              >
                <IconRemove />
              </ButtonRounded>
              <ButtonRounded v-if="makingIndex == makingDetails.content.length - 1" @action="addNewRow(makingDetails, 'makings')" color="blue">
                <IconAdd />
              </ButtonRounded>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- =================== -->
    <!-- === REFINEMENTS === -->
    <!-- =================== -->
    <section ref="print5">
      <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
        <h2>{{ $t("lang.msg.refinements") }}</h2>
      </div>
      <div class="bg-white p-4 md:p-8">
        <div
          v-for="(refinement, refinementIndex) in refinements.content"
          :key="`refinement_${refinementIndex}`"
          class="grid grid-row-1 grid-cols-1 md:grid-cols-2 xl:grid-cols-sheet gap-2 mb-8 xl:mb-4 items-end"
        >
          <label class="inline-flex items-center cursor-pointer mb-1">
            <input
              v-model="refinements.finishMain"
              class="form-radio"
              type="radio"
              name="refinement"
              :value="refinementIndex"
            >
            <span class="ml-2">{{ $t("lang.msg.main") }}</span>
          </label>
          <InputWrapper :label="$t('lang.msg.refinements')" content="input" block>
            <Select
              id="idFinishList"
              ref="idFinishList"
              :data="refinementsSelect"
              :track-by="getLangLabel('finishList')"
              v-model.number="refinement.idFinishList"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.ubication')" content="input" block>
            <Select
              id="idUbication"
              :data="ubications"
              :error="false"
              :track-by="getLangLabel('ubication')"
              v-model.number="refinement.idUbication"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.description')" content="input" block>
            <InputText v-model="refinement.finishText" :name="$t('lang.msg.description')" />
          </InputWrapper>
          <div class="flex justify-end">
            <div class="flex space-x-2">
              <ButtonRounded
                v-if="refinements.content.length > 1"
                @action="removeRowOrOpenModal(refinements.content, refinementIndex, 'idFinish')"
                color="red"
              >
                <IconRemove />
              </ButtonRounded>
              <ButtonRounded v-if="refinementIndex == refinements.content.length - 1" @action="addNewRow(refinements, 'refinements')" color="blue">
                <IconAdd />
              </ButtonRounded>
            </div>
          </div>
        </div>
      </div>
    </section>
      </div>
    <div class="flex justify-end bg-white mt-8 p-8">
      <ButtonAction @action="printSheet" class="mr-auto">
        {{ $t("lang.msg.print") }}
      </ButtonAction>
      <ButtonAction @action="saveOrUpdateTechnicalSheet">
        {{ $t("lang.msg.save") }}
      </ButtonAction>
    </div>

    <TheModal :open="isDeleteModalOpen" @close="isDeleteModalOpen = false" :title="$t('lang.msg.removeRecord')">
      <template #body>
        <p class="mt-4 pr-16 text-primario">
          {{ $t('lang.msg.sureToRemoveItem?') }}
          <br>
          {{ $t('lang.msg.cannotBeUndone') }}
        </p>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 hover:bg-red-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="removeItem"
            @keyup.enter="removeItem"
          >{{ $t('lang.msg.remove') }}</button>
        </span>
      </template>
    </TheModal>
  </div>
</template>

<script>
import UtilsMixin from "@/components/mixins/UtilsMixin";
import TheModal from "@/components/shared/TheModal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from 'html2canvas';
import Vue from 'vue';
Vue.use(html2canvas);
export default {
  name: "TechnicalSheet",
  mixins: [UtilsMixin],
  components: {
    TheModal
  },
  data() {
    return {
        url:'',
      idDesign: 0,
      isEditing: false,
      // MODAL VALUES
      currentElement: {},
      isDeleteModalOpen: false,
      // DATASHEET SELECT VALUES.
      compositionsSelect: [],
      printsSelect: [],
      complementsSelect: [],
      makingDetailsSelect: [],
      refinementsSelect: [],
      ubications: [],
      tissues: [],
      qualities: [],
      weights: [],
      titles: [],
      lus: [],
      galga: [],
        comercialRequestReference2: null,
      joinLifes: [
        { id: true, name: "Join Life" },
        { id: false, name: "No Join Life" }
      ],
      compositions: {},
      garments: {
        clotheFeatureMain: 0,
        content: [
          {
            idDesign: parseInt(this.$route.params.idDesign),
            idHound: 0,
            idLu: 0,
            idQuality: 0,
            idTissue: 0,
            idTittle: 0,
            idWeight: 0,
            idClotheFeature: 0,
            compositions: {
              clotheFeatureCompositionMain: 0,
              content: [ { idCompositionList: 0 } ]
            }
          }
        ]
      },
      prints: {
        printsMain: 0,
        content: [
          {
            idDesign: parseInt(this.$route.params.idDesign),
            idPrintList: 0,
            idUbication: 0
          }
        ]
      },
      complements: {
        complementMain: 0,
        content: [
          {
            idDesign: parseInt(this.$route.params.idDesign),
            idComplementList: 0,
            idUbication: 0
          }
        ]
      },
      makingDetails: {
        makingDetailMain: 0,
        content: [
          {
            idDesign: parseInt(this.$route.params.idDesign),
            idMakingList: 0,
            idUbication: 0
          }
        ]
      },
      refinements: {
        finishMain: 0,
        content: [
          {
            idDesign: parseInt(this.$route.params.idDesign),
            idFinishList: 0,
            idUbication: 0
          }
        ]
      }
    };
  },
  created() {
    this.idDesign = parseInt(this.$route.params.idDesign);
    this.fetchData();
    this.fetchDataSheet();
  },
  methods: {
      async printSheet(){
          let el = this.$refs.print;
          const i = (await html2canvas(el, {scrollY: -window.scrollY}));
          const doc = new jsPDF({
              orientation: "landscape",
              unit: "px",
              format: [i.width, i.height*2]
          });
          doc.addImage(i,'JPEG',0,0,i.width,i.height)
          const currentDate = this.$moment().format("DDMMYYYY HHmmss");
          doc.save(`TechnicalData_${currentDate}.pdf`);
      },
    fetchData() {
      let langParams = {
        lang: this.language
      };
      Promise.all([
        this.$axios.post(`api/CompositionLists/GetCompositionList`, langParams),
        this.$axios.post(`api/PrintLists/GetPrintList`, langParams),
        this.$axios.post(`api/ComplementLists/GetComplementList`, langParams),
        this.$axios.post(`api/MakingLists/GetMakingList`, langParams),
        this.$axios.post(`api/FinishLists/GetFinishList`, langParams),
        this.$axios.post(`api/Ubications/GetUbication`, langParams),
        this.$axios.post(`api/Tissues/GetTissue`, langParams),
        this.$axios.post(`api/Qualities/GetQuality`, langParams),
        this.$axios.post(`api/Weights/GetWeights`, langParams),
        this.$axios.get(`api/Tittles/GetTittle`),
        this.$axios.get(`api/Lus/GetLu`),
        this.$axios.get(`api/Hounds/GetHound`),
        this.$axios.post(`api/Designs/GetDesign`,{idDesign: this.idDesign})
      ]).then(values => {
        this.compositionsSelect = this.getActive(values[0].data, 'active');
        this.printsSelect = this.getActive(values[1].data, 'active');
        this.complementsSelect = this.getActive(values[2].data, 'active');
        this.makingDetailsSelect = this.getActive(values[3].data, 'active');
        this.refinementsSelect = this.getActive(values[4].data, 'active');
        this.ubications = this.getActive(values[5].data, 'active');
        this.tissues = this.getActive(values[6].data, 'active');
        this.qualities = this.getActive(values[7].data, 'active');
        this.weights = this.getActive(values[8].data, 'active');
        this.titles = this.getActive(values[9].data, 'active');
        this.lus = this.getActive(values[10].data, 'active');
        this.galga = this.getActive(values[11].data, 'active');
        // this.reference2 = values[12].data.reference2
        this.comercialRequestReference2 = values[12].data[0].comercialRequestReference2 // TODO: CAMBIAR POR REFERENCIA INTERNA 2
      });
    },
    fetchDataSheet() {
      let params = {
        idDesign: this.idDesign
      };

      Promise.all([
        this.$axios.post(`api/DataSheets/GetAllClothe`, params),
        this.$axios.post(`api/DataSheets/GetAllPrint`, params),
        this.$axios.post(`api/DataSheets/GetAllComplement`, params),
        this.$axios.post(`api/DataSheets/GetAllMaking`, params),
        this.$axios.post(`api/DataSheets/GetAllFinish`, params),
        this.$axios.post(`api/DataSheets/GetAllComposition`, params)
      ]).then(values => {
        // Si estamos editando una ficha técnica.
        if (values[0].data.length > 0) {
          this.isEditing = true;
          let clotheFeatures = values[0].data;
          this.prints = values[1].data;
          this.complements = values[2].data;
          this.makingDetails = values[3].data;
          this.refinements = values[4].data;
          this.compositions = values[5].data;

          this.formatArrays(clotheFeatures);
        }
      });
    },
    /**
     * We have to format 5 arrays to fit the needs of the template (The API returns the data unformatted).
     */
    formatArrays(clotheFeatures) {
      let garmentCompositions = {};
      let sectionMain = 0;
      let sectionContent = [];

      // === Formateo de CLOTHE FEATURE. ===
      this.garments = {};
      sectionMain = clotheFeatures.findIndex(element => {
        return element.clotheFeatureMain;
      });

      // ITERAMOS SOBRE TODAS LAS PRENDAS
      sectionContent = clotheFeatures.map(el => {
        // FILTRAMOS LAS COMPOSICIONES DE LA PRENDA.
        garmentCompositions = this.compositions.filter(element => {
          return element.idClotheFeature == el.idClotheFeature;
        });

        return {
          idDesign: el.idDesign,
          idTissue: el.idTissue,
          idQuality: el.idQuality,
          idWeight: el.idWeight,
          joinLife: el.joinLife,
          idTittle: el.idTittle,
          idLu: el.idLu,
          idHound: el.idHound,
          idClotheFeature: el.idClotheFeature,
          compositions: {
            clotheFeatureCompositionMain: 0,
            content: garmentCompositions === undefined ? [{}] : garmentCompositions
          }
        };
      });

      this.$set(this.garments, "clotheFeatureMain", sectionMain);
      this.$set(this.garments, "content", sectionContent);

      // === Formateo de PRINTS. ===
      sectionMain = this.prints.findIndex(element => {
        return element.printMain; // No es `printsMain`, porque me lo envía como `printMain`
      });
      sectionContent = this.prints.map(el => {
        return {
          idDesign: el.idDesign,
          idPrint: el.idPrint,
          idPrintList: el.idPrintList,
          idUbication: el.idUbicationPrint,
          printText: el.printText
        };
      });

      this.prints = {};
      this.$set(this.prints, "printsMain", sectionMain);
      this.$set(this.prints, "content", sectionContent);

      // === Formateo de COMPLEMENTS. ===
      sectionMain = this.complements.findIndex(element => {
        return element.complementMain;
      });
      sectionContent = this.complements.map(el => {
        return {
          idDesign: el.idDesign,
          idComplement: el.idComplement,
          idComplementList: el.idComplementList,
          idUbication: el.idUbicationComplement,
          complementText: el.complementText
        };
      });

      this.complements = {};
      this.$set(this.complements, "complementMain", sectionMain);
      this.$set(this.complements, "content", sectionContent);

      // === Formateo de MAKING DETAILS. ===
      sectionMain = this.makingDetails.findIndex(element => {
        return element.makingDetailMain;
      });
      sectionContent = this.makingDetails.map(el => {
        return {
          idDesign: el.idDesign,
          idMakingDetail: el.idMakingDetail,
          idMakingList: el.idMakingList,
          idUbication: el.idUbicationMaking,
          makingDetailText: el.makingDetailText
        };
      });

      this.makingDetails = {};
      this.$set(this.makingDetails, "makingDetailMain", sectionMain);
      this.$set(this.makingDetails, "content", sectionContent);

      // === Formateo de REFINEMENTS. ===
      sectionMain = this.refinements.findIndex(element => {
        return element.finishMain;
      });
      sectionContent = this.refinements.map(el => {
        return {
          idDesign: el.idDesign,
          idFinish: el.idFinish,
          idFinishList: el.idFinishList,
          idUbication: el.idUbicationFinish,
          finishText: el.finishText
        };
      });

      this.refinements = {};
      this.$set(this.refinements, "finishMain", sectionMain);
      this.$set(this.refinements, "content", sectionContent);
    },
    /**
     *  Adds a new row on the DataSheet section.
     */
    addNewRow(item, customData) {
      switch (customData) {
        case "garments":
          item.content.push({
            compositions: {
              clotheFeatureCompositionMain: 0,
              content: [ { idCompositionList: 0 } ]
            },
            new: true,
            idClotheFeature: 0,
            idDesign: this.idDesign
          });
          break;
        case "compositions":
          item.content.push({
            new: true,
            idCompositionList: 0
          });
          break;
        case "prints":
          item.content.push({
            new: true,
            idDesign: this.idDesign,
            idPrintList: 0,
            idUbication: 0
          });
          break;
        case "complements":
          item.content.push({
            new: true,
            idDesign: this.idDesign,
            idComplementList: 0,
            idUbication: 0
          });
          break;
        case "makings":
          item.content.push({
            new: true,
            idDesign: this.idDesign,
            idMakingList: 0,
            idUbication: 0
          });
          break;
        case "refinements":
          item.content.push({
            new: true,
            idDesign: this.idDesign,
            idFinishList: 0,
            idUbication: 0
          });
          break;
      }
    },
    /**
     *  Checks if the property is different than 0 (Does not exists on the database) and then...
     *  either is removed from the array or removed from the database.
     */
    removeRowOrOpenModal(array, index, property) {
      // Si el idDesign de ese elemento es 0, entonces lo podemos eliminar sin confirmación.
      if (array[index]["new"] !== undefined) {
        array.splice(index, 1);
      } else {
        this.currentElement = {
          array: array,
          index: index,
          property: property
        };
        this.isDeleteModalOpen = true;
      }
    },
    /**
     *  Removes the item after its beign confirmed in the modal.
     */
    removeItem() {
      let element = this.currentElement;
      let property = element.array[element.index][element.property];

      // Send the delete request.
      this.$axios
        .post(`api/DataSheets/Remove`, {
          [this.currentElement.property]: property
        })
        .then(() => {
          element.array.splice(element.index, 1);
          this.openAlert('success', 'Registro eliminado', null);
          this.isDeleteModalOpen = false;
          this.currentElement = {};
        });
    },
    /**
     *  Saves the DataSheet and returns to Design view.
     */
    saveOrUpdateTechnicalSheet() {
      // Group all the DataSheet into 1 object.
      let allTechnicalSheet = {
        idUser: this.user.id,
        clotheFeatures: this.garments,
        prints: this.prints,
        complements: this.complements,
        makingDetails: this.makingDetails,
        finishes: this.refinements
      };

      let url = "";
      if (this.isEditing) url = "api/DataSheets/Update";
      else url = "api/DataSheets/Add";

      // Save and return to Design
      this.$axios
        .post(url, allTechnicalSheet)
        .then(() => {
          this.openAlert("success", "Ficha técnica guardada", null);
          this.$router.back();
        })
        .catch(() => this.showFriendlyError());
    }
  }
};
</script>
